import type { Contexts } from "@sentry/core";
import type { AxiosError } from "axios";

export function ifAxiosErrorAddContext(eventContexts: Contexts | undefined, exception: AxiosError) {
	if (exception.isAxiosError) {
		const contexts = {
			...eventContexts,
		};

		if (exception.response) {
			// The request was made and the server responded with a status code
			// that falls out of the range of 2xx
			contexts.errorResponse = {
				message: exception.message,
				data: exception.response.data,
				status: exception.response.status,
				headers: exception.response.headers,
			};
		} else if (exception.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			contexts.errorResponse = {
				message: exception.message,
				request: exception.request,
			};
		} else {
			// Something happened in setting up the request that triggered an Error
			contexts.errorResponse = {
				message: exception.message,
			};
		}

		// We add the config anyway for info
		contexts.errorResponse = {
			...contexts.errorResponse,
			config: exception.config,
		};

		return contexts;
	}

	// If it's not axiosError we return original context
	return eventContexts;
}
